import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="paddle"
export default class extends Controller {
  static values = {
    data: Object,
    cancelUrl: String,
  };

  connect() {
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.removedNodes) {
          if (node.matches('iframe[src*="paddle"]')) {
            console.log("paddle iframe removed");
            console.log(this.cancelUrlValue);
           // Turbo.visit(this.cancelUrlValue);
          }
        }
      }
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    this.pay();
  }

  pay() {
    Paddle.Checkout.open(this.dataValue);
  }

  disconnect() {
    this.observer.disconnect();
  }
}
